import {
  Modal as ChakraModal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  Text,
} from '@chakra-ui/react'
import { Td, Th } from '../../ResumoProducao/styles'
import { formatDate } from '../../../../utils/formatDate'
import { Table, TableContainer, Tbody, Thead, Tr } from '@chakra-ui/table'
import React from 'react'
import { firstLetterUpperCaseAndRestLowerCase } from '../../../../utils/capitalFirstLetter'
import { Row } from '../Row'

export function ModalFaltante({ item, itemFaltante, loading }) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  function handleClick() {
    onOpen()
  }

  console.log(item)

  return (
    <>
      <Button onClick={handleClick}>{item.contador_pedidos + '/' + item.contador_tela}</Button>

      <ChakraModal isOpen={isOpen} onClose={onClose} size="7xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Informações do item</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {loading && (
              <Text fontSize="xl" fontWeight="bold" color="blue.500" textAlign={'center'}>
                Carregando...
              </Text>
            )}
            {!loading && itemFaltante.length === 0 && (
              <Text fontSize="xl" fontWeight="bold" color="blue.500" textAlign={'center'}>
                Nenhum item faltante
              </Text>
            )}

            {!loading && itemFaltante.length !== 0 && (
              <TableContainer maxW="100%" overflowX="auto" height="calc(100vh - 20rem)" overflowY="auto">
                <Table size="sm" variant="striped">
                  <Thead position="sticky" top="0" bg="#378BBF" zIndex="1">
                    <Tr>
                      <Th>Pedido</Th>
                      <Th>Codigo</Th>
                      <Th>Descrição</Th>
                      <Th>Cor</Th>
                      <Th>Quantidade</Th>
                      <Th>Passo atual</Th>
                      <Th>Próximo passo</Th>
                      <Th>Prazo</Th>
                      {/*<Th>Material pronto</Th>*/}
                      <Th>Limite de produção</Th>
                      <Th>Entrega</Th>
                    </Tr>
                  </Thead>

                  {!loading && (
                    <Tbody>
                      {itemFaltante.map((item, index) => (
                        <Tr>
                          <Td>
                            <Text
                              as={'a'}
                              color={item.LINK_LAYOUT === '' || !item.LINK_LAYOUT ? 'red.500' : 'blue.500'}
                              href={item.LINK_LAYOUT}
                              _hover={{ textDecoration: 'underline', filter: 'brightness(0.8)' }}
                              target="_blank"
                              rel="noreferrer"
                              cursor="pointer"
                            >
                              {firstLetterUpperCaseAndRestLowerCase(item.PEDIDO)}
                            </Text>
                          </Td>
                          <Td>{firstLetterUpperCaseAndRestLowerCase(item.CODIGO)}</Td>

                          <Td>{firstLetterUpperCaseAndRestLowerCase(item.DESCRICAO)}</Td>
                          <Td>{firstLetterUpperCaseAndRestLowerCase(item.COR)}</Td>
                          <Td>{item.batidas && item.batidas > 1 ? item.QUANTIDADE + ' x ' + item.batidas : item.QUANTIDADE}</Td>

                          <Td>{firstLetterUpperCaseAndRestLowerCase(item.PASSO_ATUAL)}</Td>
                          <Td>{firstLetterUpperCaseAndRestLowerCase(item.PROXIMO_PASSO)}</Td>
                          <Td>{firstLetterUpperCaseAndRestLowerCase(item.PRAZO) + ' dias'}</Td>
                          {/*<Td>{item.dt_material_pronto}</Td>*/}
                          <Td>{formatDate(item.limite_producao, true)}</Td>
                          <Td>{firstLetterUpperCaseAndRestLowerCase(item.ENTREGA)}</Td>
                        </Tr>
                      ))}
                    </Tbody>
                  )}
                </Table>
              </TableContainer>
            )}
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
            {/*<Button variant="ghost">Secondary Action</Button>*/}
          </ModalFooter>
        </ModalContent>
      </ChakraModal>
    </>
  )
}
